export default __webpack_public_path__ + "static/media/E13.76be4f5b.jpeg";